import { render } from "./GroupItem.vue?vue&type=template&id=22caeb3f"
import script from "./GroupItem.vue?vue&type=script&lang=js"
export * from "./GroupItem.vue?vue&type=script&lang=js"
script.render = render

export default script